<template>
  <div
    class="wrapper pa-4"
  >
    <h1>threejs canvas截图</h1>
    <p>
      首先自适应宽度 根据canvas的实际宽高来渲染并不会导致失真
      <canvas
        id="c2"
        style="border: 1px solid;width: 100%;max-height: 20vh"
      />
    </p>
    <p>
      截图需要把render函数提出来 在截图前render函数执行一次
      <canvas
        id="c3"
        style="border: 1px solid;width: 100%;max-height: 20vh"
      />
      <v-btn
        class="my-2"
        @click="screenShotDownload"
      >
        截图并下载
      </v-btn>
      <v-btn
        class="my-2"
        @click="screenShot"
      >
        截图
      </v-btn>
      <img
        id="img"
        src=""
        alt="截图"
        style="display: none;"
      >
      <highlightjs
        class="mt-4"
        :code="`screenShotDownload() {
  const saveBlob = (function() {
  const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    return function saveData(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
    };
  }());

  this.render3();
  const canvas = document.getElementById('c3');
  canvas.toBlob((blob) => {
    saveBlob(blob, 'screencapture.png');
  });
},
screenShot() {
  this.render3();
  const canvas = document.getElementById('c3');
  const img = document.getElementById('img');
  const url = canvas.toDataURL();
  img.src = url;
  img.style.display = 'block';
},`"
        :language="'js'"
      />
    </p>
  </div>
</template>

<script type="module">
import * as THREE from 'three';

export default {
  data() {
    return {

      state3: {
        time: 0,
      },
      renderer3: null,
      scene: null,
      camera: null,
      cube: null,
    };
  },
  mounted() {
    this.main2();
    this.init3();

    this.animate3();
  },
  methods: {
    main2() {
      // canvas
      const canvas = document.querySelector('#c2');
      // 渲染器 antialias代表是否开启抗锯齿
      const renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      const camera = new THREE.PerspectiveCamera(75, 2, 0.1, 5);

      // 摄像机位置
      camera.position.x = 0;
      camera.position.z = 3;
      camera.position.y = 0.5;

      // 创建场景
      const scene = new THREE.Scene();

      // 几何体 宽 高 深
      const geometry = new THREE.BoxGeometry(1, 1, 2);

      // 材质
      const material = new THREE.MeshPhongMaterial({
        color: '#FFDD11',
      });

      // 再创建一个网格(Mesh)对象，它包含了 geometry(几何体 物体的形状) material(材质 如何绘制物体，光滑还是平整，什么颜色，什么贴图..)
      const cube = new THREE.Mesh(geometry, material);
      
      // 最后我们将网格添加到场景中。
      scene.add(cube);
      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      renderer.render(scene, camera);

      // 灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      scene.add(light);

      // 判断画布是否需要调整大小
      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }

      // 立方体旋转
      function render(time) {
        time *= 0.001;  // 将时间单位变为秒

        // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          camera.updateProjectionMatrix();
        }
      
        cube.rotation.x = time;
        cube.rotation.y = time;
      
        renderer.render(scene, camera);
      
        requestAnimationFrame(render);
      }
      requestAnimationFrame(render);
    },
    init3() {
      // canvas
      const canvas = document.querySelector('#c3');
      // 渲染器 antialias代表是否开启抗锯齿
      this.renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      this.camera = new THREE.PerspectiveCamera(75, 2, 0.1, 5);

      // 摄像机位置
      this.camera.position.x = 0;
      this.camera.position.z = 3;
      this.camera.position.y = 0.5;

      // 创建场景
      this.scene = new THREE.Scene();

      // 几何体 宽 高 深
      const geometry = new THREE.BoxGeometry(1, 1, 2);

      // 材质
      const material = new THREE.MeshPhongMaterial({
        color: '#33DDee',
      });

      // 再创建一个网格(Mesh)对象，它包含了 geometry(几何体 物体的形状) material(材质 如何绘制物体，光滑还是平整，什么颜色，什么贴图..)
      this.cube = new THREE.Mesh(geometry, material);
      
      // 最后我们将网格添加到场景中。
      this.scene.add(this.cube);
      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      this.renderer.render(this.scene, this.camera);

      // 灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      this.scene.add(light);
    },

      // 判断画布是否需要调整大小
    resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    },
    render3() {
      const speed = 0.1;
      const rot = this.state3.time * speed;
      // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
      if (this.resizeRendererToDisplaySize(this.renderer)) {
        const canvas = this.renderer.domElement;
        this.camera.aspect = canvas.clientWidth / canvas.clientHeight;
        this.camera.updateProjectionMatrix();
      }

      this.cube.rotation.x = rot;
      this.cube.rotation.y = rot;

      this.renderer.render(this.scene, this.camera);

      requestAnimationFrame(this.render3);
    },
    animate3(time) {
      this.state3.time = time * 0.01;
    
      this.render3();
    
      requestAnimationFrame(this.animate3);
    },
    screenShotDownload() {
      const saveBlob = (function() {
      const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        return function saveData(blob, fileName) {
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
        };
      }());

      this.render3();
      const canvas = document.getElementById('c3');
      canvas.toBlob((blob) => {
        saveBlob(blob, `screencapture-${canvas.width}x${canvas.height}.png`);
      });
    },
    screenShot() {
      this.render3();
      const canvas = document.getElementById('c3');
      const img = document.getElementById('img');
      const url = canvas.toDataURL();
      img.src = url;
      img.style.display = 'block';
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>